module.exports = __webpack_public_path__ + "img/collapse-arrow.a4d9bb82.svg";